<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
  
      <div id="navTop" class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">赚金币</div>
        <div class="nav-right">
          <img src="../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="tasks-box">
        <div class="sign ub ub-ver ub-pc">
          <ul class="sign-block ub ub-ver">
            <div class="ub ub-ac tit">已连续签到{{ is_sign == 1 ? is_sign_day + 1 : is_sign_day }}天</div>
            <div class="ub ub-ac3">
              <li class="ub" v-for="(item, index) in signDays" :key="index" @click="sign()">
                <div :class="is_sign_day > index || (is_sign == 1 && is_sign_day == index) ? 'item' : 'item2'">
                  <span class="sp1">{{ is_sign_day == index ? '今天' : `第${index + 1}天` }}</span>
                  <img :src="is_sign_day > index || (is_sign == 1 && is_sign_day == index) ? imgUrl : imgUrl2" />
                  <span class="sp2">{{ item.coin }}金币</span>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <ul class="tasks-list">

          <li class="item" v-if="task_newuser_1.is_show">
              <div class="integral">
                <img src="../assets/img/new2024/personal.png" alt="">
              </div>
              <div class="score">
                <span class="reward">萌新福利</span>
                <div class="integrals">金币+{{ task_newuser_1.coin }},<span>{{ task_newuser_1.note }}</span></div>
              </div>
            <button class="btn btn-2" v-if="task_newuser_1.state == 2" @click="receive(task_newuser_1)">待领取</button>
            <button class="btn btn-3" v-if="task_newuser_1.state == 3" @click="toast_Received()">已领取</button>
          </li>

          <div class="line" v-if="task_newuser_1.is_show"></div>

          <li class="item" v-if="task_newuser_2.is_show">
              <div class="integral">
                <img src="../assets/img/new2024/personal.png" alt="">
              </div>
              <div class="score">
                <span class="reward">萌新福利</span>
                <div class="integrals">金币+{{ task_newuser_2.coin }},<span>{{ task_newuser_2.note }}</span></div>
              </div>
            <button class="btn btn-2" v-if="task_newuser_2.state == 2" @click="receive(task_newuser_2)">待领取</button>
            <button class="btn btn-3" v-if="task_newuser_2.state == 3" @click="toast_Received()">已领取</button>
          </li>

          <div class="line" v-if="task_newuser_2.is_show"></div>

          <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/task-vip.png" alt="">
              </div>
              <div class="score">
                <span class="reward">会员特权</span>
                <div class="integrals">金币+{{ vip_rights.coin }},<span>{{ vip_rights.note }}</span></div>
              </div>
            <button class="btn btn-2" v-if="vip_rights.state == 2" @click="receive(vip_rights)">待领取</button>
            <button class="btn btn-3" v-if="vip_rights.state == 3" @click="toast_Received()">已领取</button>
            <button class="btn btn-5" v-if="vip_rights.state == 5" @click="unlock()">待解锁</button>
          </li>

          <div class="line"></div>
        
          <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/login.png" alt="">
              </div>
              <div class="score">
                <span class="reward">每日登录</span>
                <div class="integrals">金币+{{ task_login.coin }},<span>{{ task_login.note }}</span></div>
              </div>
            <button class="btn btn-2" v-if="task_login.state == 2" @click="receive(task_login)">待领取</button>
            <button class="btn btn-3" v-if="task_login.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
          <div class="line"></div>

          <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/hello.png" alt="">
              </div>
              <div class="score">
                <span class="reward">打招呼奖励</span>
                <div class="integrals">金币+{{ task_hello.coin }},<span>{{ task_hello.note }}</span></div>
              </div>
            <button class="btn btn-1" v-if="task_hello.state == 1" @click="goto_finish('hello')">+{{ task_hello.coin }}金币</button>
            <button class="btn btn-2" v-if="task_hello.state == 2" @click="receive(task_hello)">待领取</button>
            <button class="btn btn-3" v-if="task_hello.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
          <div class="line"></div>

          <li class="item">
              <div class="integral">
                <img src="../assets/img/new2024/news.png" alt="">
              </div>
              <div class="score">
                <span class="reward">回复奖励</span>
                <div class="integrals">金币+{{ task_answer.coin }},<span>{{ task_answer.note }}</span></div>
              </div>
            <button class="btn btn-1" v-if="task_answer.state == 1" @click="goto_finish('msg')">+{{ task_answer.coin }}金币</button>
            <button class="btn btn-2" v-if="task_answer.state == 2" @click="receive(task_answer)">待领取</button>
            <button class="btn btn-3" v-if="task_answer.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
          <div class="line"></div>
  
          <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/personal.png" alt="">
            </div>
            <div class="score">
              <span class="reward">在线奖励</span>
              <div class="integrals" v-html="task_online.tips"></div>
            </div>
            <button class="btn btn-2" v-if="task_online.state == 2" @click="receive_online(task_online)">待领取</button>
            <button class="btn btn-22" v-if="task_online.state == 22" @click="goto_finish('msg')">继续</button>
          </li>
  
          <div class="line"></div>
  
          <li class="item">
            <div class="integral">
              <img src="../assets/img/new2024/share.png" alt="">
            </div>
            <div class="score">
              <div class="reward-no">分享奖励(敬请期待)</div>
              <div class="integrals">金币+{{ task_share.coin }},<span>{{ task_share.note }}</span></div>
            </div>
          <button class="btn btn-1" v-if="task_share.state == 1" @click="task_share_alert(task_share)">未完成</button>
          <button class="btn btn-2" v-if="task_share.state == 2" @click="receive(task_share)">待领取</button>
          <button class="btn btn-3" v-if="task_share.state == 3" @click="toast_Received()">已领取</button>
          </li>
  
        </ul>

        <div style="height: 2rem;"></div>
  
      </div>
      
      <dlg ref="myForm" @formBehavior="formBehaviorFun"></dlg>
      <dlg ref="myForm_buyVip" @formBehavior="formact_buyVip"></dlg>
      <sign_boy ref="myForm_boySign" @SignState="getSignState"></sign_boy>
      <reward_coin ref="show_reward_coin"></reward_coin>
    </div>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import Form from "../components/Form.vue";
  import Form_BoySign from "../components/Sign.vue";
  import Coin_Reward from "../components/Coin_Reward.vue";
  import * as tool from "../api/common";
  export default {
    components: {
      dlg: Form,
      sign_boy: Form_BoySign,
      reward_coin: Coin_Reward
    },
    data() {
      return {
        task_login: {
          "title": "每日登录",
          "task_type": 1,
          "coin": 10,
          "state": 2,
          "note": "每天登录就可领取"
        },
        task_hello: {
          "title": "打招呼奖励",
          "task_type": 2,
          "coin": 50,
          "state": 1,
          "note": "完成10次打招呼就可领取"
        },
        task_answer: {
          "title": "回复奖励",
          "task_type": 3,
          "coin": 50,
          "state": 1,
          "note": "完成10次回复就可领取"
        },
        task_share: {
          "title": "分享奖励",
          "task_type": 4,
          "coin": 80,
          "state": 1,
          "note": "分享到朋友圈或者微信好友即可得奖励",
          "alert_txt": "点击右上角三个点，分享到朋友圈、微信好友、群聊天，即可领取该奖励，赶快去分享吧~<br/>该功能正在开发中，敬请期待~"
        },
        task_online: {
          "title": "在线奖励",
          "task_type": 5,
          "coin": 1,
          "state": 2,
          "note": "",
          "tips": "金币+1，今日已在线1分钟，在线时间越长，奖励越高"
        },
        vip_rights: {
          "title": "会员奖励",
          "task_type": 6,
          "coin": 1000,
          "state": 5,
          "note": "会员每天可领1000金币"
        },
        task_newuser_1: {
          "title": "萌新奖励",
          "task_type": 11,
          "coin": 200,
          "state": 2,
          "note": "明天还可领300金币",
          "is_show": false
        },
        task_newuser_2: {
          "title": "萌新奖励",
          "task_type": 12,
          "coin": 300,
          "state": 2,
          "note": "明天还可领300金币",
          "is_show": false
        },
        
        theme_dark: false,
        userinfo: {
          vip_level: 0,
          reg_time: 0
        },
        signDays: [
          { coin: 10 },
          { coin: 20 },
          { coin: 30 },
          { coin: 40 },
          { coin: 50 },
          { coin: 60 },
          { coin: 100 }
        ],
        is_sign_day: 0,
        is_sign: 0,
        imgUrl: require("../assets/img/金币.png"),
        imgUrl2: require("../assets/img/金币灰色.png"),
        serve_data: []
      };
    },
    mounted() {
      tool.clear_online_action();
      tool.clear_chat_coin_hello();
      tool.clear_chat_coin_answer();
  
      this.loading("加载中...",5000);
  
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_user();

      this.init();

      
    },
  
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
  
      init(){
        this.init_task_state();
        
        var uid = this.$store.state.uid;
        var self = this;
        this.get({
            url: "/App/GetTaskCoinState?uid=" + uid,
            success: function (data) {
              self.$loading.close();
              self.serve_data = data;
              self.init_serveData(data);
              self.init_sign();
            },
            error: function (err){}
          });
          
      },

      init_task_state() {
          //萌新福利第一天
          if (this.userinfo.reg_time <= 86400 * 1) {
              this.task_newuser_1.state = 2;
              this.task_newuser_1.is_show = true;
          }

          //萌新福利第二天
          if (this.userinfo.reg_time > 86400 * 1 && this.userinfo.reg_time <= 86400 * 2) {
            this.task_newuser_2.state = 2;
            this.task_newuser_2.is_show = true;
          }

          //会员权益
          var vip_level = this.userinfo.vip_level;
          if (vip_level > 0) {
            this.vip_rights.state = 2;
          }

          //打招呼
          var loc_chat_hello = JSON.parse(localStorage.getItem("loc_chat_hello")) || [];
          if (loc_chat_hello.length >= 10) {
            this.task_hello.state = 2;
            this.task_hello.note = "恭喜你,任务已完成,点击领取奖励吧";
          }

          //回复
          var loc_chat_answer = JSON.parse(localStorage.getItem("loc_chat_answer")) || [];
          if (loc_chat_answer.length >= 10) {
            this.task_answer.state = 2;
            this.task_answer.note = "恭喜你,任务已完成,点击领取奖励吧";
          }
      },

      init_serveData(serve_data) {
        //每日登录
        var task_login = serve_data.filter(item=> item.type_dtl == "任务奖励-登录");
        if (task_login.length > 0) {
          this.task_login.state = 3;
        } 
        //打招呼
        var task_hello = serve_data.filter(item=> item.type_dtl == "任务奖励-打招呼");
        if (task_hello.length > 0) {
          this.task_hello.state = 3;
          this.task_hello.note = "恭喜你,今日已成功领取50金币";
        }
        //回复
        var task_answer = serve_data.filter(item=> item.type_dtl == "任务奖励-回复");
        if (task_answer.length > 0) {
          this.task_answer.state = 3;
          this.task_answer.note = "恭喜你,今日已成功领取50金币";
        }
        //在线
        var task_online = serve_data.filter(item=> item.type_dtl == "任务奖励-在线");
        if (task_online.length > 0) {
          this.init_task_online(task_online);
        }
        
        //会员
        var task_vip = serve_data.filter(item=> item.type_dtl == "任务奖励-会员");
        if (task_vip.length > 0) {
          this.vip_rights.state = 3;
        }
        //萌新第一天
        var newuser_1 = serve_data.filter(item=> item.type_dtl == "newuser_1");
        if (newuser_1.length > 0) {
          this.task_newuser_1.state = 3;
        }
        //萌新第二天
        var newuser_2 = serve_data.filter(item=> item.type_dtl == "newuser_2");
        if (newuser_2.length > 0) {
          this.task_newuser_2.state = 3;
        }
      },

      init_user(uid) {
        var uid = this.$store.state.uid;
        var self = this;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            self.userinfo = u;
            self.userinfo.vip_level = u.vip_level;
            self.userinfo.reg_time = u.reg_time;
          },
        });
      },

      init_sign() {
        var sign = this.serve_data.filter(item=> item.type_dtl == "签到");
        if (sign.length > 0) {
          this.is_sign = 1;
        } else {
          this.is_sign = 0;
        }
      },

      sign() {
        var my_sign = this.$store.state.http_cache.my_sign;
        if (my_sign.is_sign != 99) {
          this.$refs.myForm_boySign.show(my_sign.is_sign);
          return false;
        } else {
          this.$refs.myForm_boySign.show(this.is_sign);
        }
      },

      //获取子组件中的签到状态
      getSignState(sign_state) {
        this.is_sign = sign_state;
      },

      init_task_online(serve_task) {
        var coin_old = 1;
        
        if (serve_task.length > 0) {
          coin_old = serve_task[0].amount;
        }

        //获取用户在线是时长
        var online_second = tool.get_online_time();
        var online_time = Math.floor(online_second / 60);
        var time_txt = "";
        if (online_time < 60) {
          time_txt = online_time + "分钟";
        } else {
          var hour = Math.floor(online_time / 60);
          var min = online_time - hour * 60;
          time_txt = hour + "小时" + min + "分钟";
        }

        
        var state = 22;
        var tips = "今日已在线"+time_txt+"，继续保持在线聊天，马上解锁新的在线奖励~";

        var coin_new = 0;
        //计算应得金币
        if (online_time <= 30) {
          coin_new = 1 + (online_time * 1);
        }
        if (online_time > 30 ) {
          coin_new = 30 + (online_time - 30) * 0.5;
          coin_new = Math.floor(coin_new);
        }
        if (coin_new >= 100) {
          coin_new = 100;
        }
        //计算状态
        if (coin_new > coin_old) {
          state = 2;
          tips = "金币+"+coin_new+"，今日已在线"+time_txt+"，在线时间越长，奖励越高";
        }

        this.task_online = {
          "title": "在线奖励",
          "task_type": 5,
          "coin": coin_new,
          "state": state,
          "note": '',
          "tips": tips
        }
      },

      goto_finish(type) {
        if (type == "msg") {
          this.$router.push({name: "msg"});
          return true;
        }
        if (type == "hello") {
          this.$router.push({name: "hello_girl"});
          return true;
        }
      },

      task_share_alert(item) {
        var h = item.alert_txt;
        var confirmText = "去完成";

        this.$refs.myForm.show(h, {
          type: "confirm",
          confirmText: confirmText,
          titleText: "分享奖励",
          data: ""
        });
      },
  
      //获取奖励状态
      receive(task) {
        this.loading("领取中...",5000);
        var reward = {
          "type": task.title,
          "coin": task.coin,
          "tips": task.note,
          "path_name":"",
          "btn_name":"收下"
        }
        this.$refs.show_reward_coin.show(reward);
        
        var uid = this.$store.state.uid;
        var self = this;
          self.get({
            url: "/App/ReceiveTaskCoin?uid=" + uid +"&task_type=" + task.task_type +"&coin=" + task.coin,
            success: function (data) {
              self.$loading.close();
              if(data.state == 1){
                task.state = 3;
                task.coin = task.coin;
                self.act_reload_userinfo();
              }
            },
            error: function (err){}
          });
      },
  
      //领取在线奖励
      receive_online(task) {
          this.loading("领取中...",5000);
          var reward = {
            "type": task.title,
            "coin": task.coin,
            "tips": task.tips,
            "path_name":"",
            "btn_name":"收下"
          }
          this.$refs.show_reward_coin.show(reward);
  
          var uid = this.$store.state.uid;
          var self = this;
          self.get({
            url: "/App/ReceiveTaskCoin?uid=" + uid +"&task_type=5&coin=" + task.coin,
            success: function (data) {
              self.$loading.close();
              if (data.state == 1) {
                task.state = 22;
                task.coin_old = task.coin;
                self.act_reload_userinfo();
              }
            },
            error: function (err){}
          });
      },
  
      formBehaviorFun(type, data) {
        if (type == "clickConfirm") {
          if (data == "打招呼奖励") {
            this.$router.push({name: "index"});
            return true;
          }

          this.$router.push({name: "msg"});
        }
      },
  
      toast_Received() {
        this.$toast.top("奖励已领取!，请不要再戳哦~"); //已领取奖励提示框
      },

      //待解锁
      unlock() {
        this.$refs.myForm_buyVip.show("升级成为会员，每天可领取1000金币，购买会员时间越长领取金币越多", {
          type: "confirm",
          confirmText: "升级会员",
          titleText: "温馨提示",
          data: ""
        });
      },
      formact_buyVip(type, data) {
        if (type == "clickConfirm") {
          this.$router.push({ name: "vip_center" });
        }
      },
  
      loading(title,time) {
        var self = this;
          this.$loading(title);
          setTimeout(() => {
              self.$loading.close();
          }, time);
      },
  
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #FDFDFD;
    background-size: 100% 100%;
    .nav-top {
      background-color: #8A61FF;
    }
    .nav-right {
      padding-right: 0.5rem;
      .nav-lable {
        margin: 0;
        font-size: 0.9rem;
        color: #fff;
      }
    }
  
    .sign {
      padding-top: 0.5rem;
      .sign-block {
        padding: 1rem 0;
        width: 100%;
        border-radius: 0.5rem;
        background-color: #FDFDFD;
        .tit {
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
          color: #ba61ff;
        }

      }
      .item {
        padding: 0.4rem 0;
        display: flex;
        flex-direction: column;
        width: 2.8rem;
        height: 4rem;
        align-items: center;
        justify-content: space-around;
        border-radius: 0.5rem;
        background: linear-gradient( 180deg, #A264E7 0%, #FE9CC0 100%);
        .sp1 {
          color: #fff;
          font-size: 0.75rem;
        }
        img {
          width: 1.2rem;
          height: 1.2rem;
        }
        .sp2 {
          color: #fff;
          font-size: 0.65rem;
        }
      }

      .item2 {
        padding: 0.4rem 0;
        background-color: #e7e7e5;
        display: flex;
        flex-direction: column;
        width: 2.8rem;
        height: 4rem;
        align-items: center;
        justify-content: space-around;
        border-radius: 0.5rem;
        span {
          color: #888888;
          font-size: 0.65rem;
          font-weight: 500;
        }
        img {
          width: 1.2rem;
          height: 1.2rem;
          pointer-events: none;
        }
      }
    }
  
    .tasks-box{
      padding: 0 0.75rem;
      background: linear-gradient(to bottom, #8A61FF, #FE9CC0, #fff 50rem);
      .tasks-list{
        margin-top: 0.5rem;
        border-radius: 0.5rem;
        background-color: #FDFDFD;
        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          color: #333;
          padding: 1rem;
            .integral {
              width: 2.1rem;
              height: 2.1rem;
              background-color: #DFD0FF;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 0.5rem;
                img {
                  width: 1rem;
                  height: 1rem;
                }
                
              }
              .score {
                flex: 1;
                padding: 0 1rem;
              }
              .reward {
                  font-size: 0.9rem;
              }
              .reward-no {
                font-size: 0.9rem;
                color: #a0a0a0;
              }
            .integrals {
                  margin-top: 0.3rem;
                  line-height: 1.2rem;
                  font-size: 0.75rem;
                  color: #808080;
            }
            
        }
        .line{
          margin: 0 1rem;
          border-top: 1px solid #EFEFEF;
        }
      }
    }
    .btn {
      font-size: 0.65rem;
      font-weight: 500;
      border: none;
       border-radius: 1rem;
       width: 4.1rem;
       height: 1.75rem;
    }
            .btn-1 {
              min-width: 4.1rem;
              white-space: nowrap;
              font-size: 0.6rem;
              background-color: transparent;
              border: 1px solid rgb(186, 97, 255);
              color: rgb(186, 97, 255);
            }

            .btn-2 {
                background-image: linear-gradient(to bottom,#2cac32,#59e064);
                color: #FFFFFF;
            }
            .btn-22 {
                background-image: linear-gradient(to bottom,#8A61FF,#FE9CC0);
                color: #FFFFFF;
            }
            .btn-3 {
                background-color: #E9E9E9;
                color: #898989;
            }
            .btn-5 {
              background-color: #E9E9E9;
              color: #e92162;
            }
  }
  
  .container-dark {
    min-height: 100vh;
    background-color: #2F2E33;
    .nav-top {
      background-color: #3c296e;
    }
    .sign {
      .item2 {
          background-color: #4d4d4b;
        }
      .sign-block {
        background-color: #2c2b30;

      }
    }
    .tasks-box {
      background: linear-gradient(to bottom,#3c296e, #5f3b48, #2F2E33 50rem);
      .tasks-list {
        background-color: #2c2b30;
        .item {
          color: #FDFDFD;
          
        }
        .line{
          margin: 0 1rem;
          border-top: 1px solid #404040;
        }
      }
    }
    .btn-1 {
      color: #FDFDFD;
    }
  }
  
  </style>
  